export const MOCK_USERS = [
  {
    id: 'u1',
    username: 'StandUpSammy',
    name: 'Sammy Jokes',
    avatar: 'https://i.pravatar.cc/150?u=u1',
    followers: '1.2M',
    following: '245',
    likes: '15.4M',
    bio: 'Just trying to make you laugh 😂\nTour dates in link!',
  },
  {
    id: 'u2',
    username: 'PunchlinePete',
    name: 'Pete',
    avatar: 'https://i.pravatar.cc/150?u=u2',
    followers: '845K',
    following: '120',
    likes: '8.2M',
    bio: 'Dad jokes are my love language.',
  },
  {
    id: 'u3',
    username: 'KaraokeKaren',
    name: 'Karen Sings',
    avatar: 'https://i.pravatar.cc/150?u=u3',
    followers: '2.1M',
    following: '50',
    likes: '22M',
    bio: 'Bad singing, good comedy 🎤',
  },
  {
    id: 'u4',
    username: 'OfficeHumor',
    name: 'Corporate Carl',
    avatar: 'https://i.pravatar.cc/150?u=u4',
    followers: '450K',
    following: '300',
    likes: '4.1M',
    bio: 'Surviving 9-5 one meme at a time 💼',
  },
]

export const MOCK_VIDEOS = [
  {
    id: 'v1',
    user: MOCK_USERS[0],
    caption: 'When mom finds the snack drawer 😂 #comedy #relatable #mom',
    likes: '245K',
    comments: '1.2K',
    shares: '45K',
    music: 'Original Audio - StandUpSammy',
    color: 'from-purple-600 to-blue-600',
    isLiked: false,
  },
  {
    id: 'v2',
    user: MOCK_USERS[1],
    caption: 'The ultimate dad joke battle part 4 👨‍👦 #dadjokes #funny',
    likes: '890K',
    comments: '4.5K',
    shares: '120K',
    music: 'Funny background music - Comedy Central',
    color: 'from-emerald-500 to-teal-700',
    isLiked: true,
  },
  {
    id: 'v3',
    user: MOCK_USERS[2],
    caption:
      'POV: You are the only one who knows the lyrics 🎤😭 #karaoke #fail',
    likes: '1.2M',
    comments: '8.9K',
    shares: '200K',
    music: 'I Will Survive (Bad Cover) - KaraokeKaren',
    color: 'from-rose-500 to-orange-600',
    isLiked: false,
  },
  {
    id: 'v4',
    user: MOCK_USERS[3],
    caption: 'When the boss says "we are a family" 🚩🚩🚩 #office #corporate',
    likes: '560K',
    comments: '2.1K',
    shares: '89K',
    music: 'Corporate Drone Anthem - OfficeHumor',
    color: 'from-slate-700 to-slate-900',
    isLiked: false,
  },
]

export const MOCK_COMMENTS = [
  {
    id: 'c1',
    user: MOCK_USERS[1],
    text: 'Bro this is too relatable 😭',
    likes: '12K',
    time: '2h',
  },
  {
    id: 'c2',
    user: MOCK_USERS[2],
    text: 'My mom literally did this yesterday',
    likes: '8.4K',
    time: '4h',
  },
  {
    id: 'c3',
    user: MOCK_USERS[3],
    text: 'The accuracy hurts',
    likes: '2.1K',
    time: '5h',
  },
  {
    id: 'c4',
    user: { username: 'randomUser1', avatar: 'https://i.pravatar.cc/150?u=r1' },
    text: 'LMAOOOO',
    likes: '456',
    time: '6h',
  },
  {
    id: 'c5',
    user: { username: 'comedyFan99', avatar: 'https://i.pravatar.cc/150?u=r2' },
    text: 'Need a part 2 ASAP',
    likes: '120',
    time: '8h',
  },
]

export const MOCK_CATEGORIES = [
  { name: 'Stand-up', emoji: '🎤' },
  { name: 'Pranks', emoji: '🤡' },
  { name: 'Skits', emoji: '🎭' },
  { name: 'Dad Jokes', emoji: '👨' },
  { name: 'Office Humor', emoji: '💼' },
  { name: 'Animals', emoji: '🐶' },
  { name: 'Fails', emoji: '🤦‍♂️' },
  { name: 'Impressions', emoji: '🗣️' },
]
